import "./textImage.scss";
//
import ButtonSolid, { ButtonSolidType } from "components/buttonSolid/buttonSolid";
import * as utils from "shell/app/app.utils";
import classNames from "classnames";

interface textImageProps {
  overlay: string;
  headline: string;
  copy: string;
  cta: ButtonSolidType;
  img: string;
  isImageBg?: boolean;
}

const TextImage: React.FC<textImageProps> = (props) => {
  return (
    <div
      className={classNames("text-image", { "is-image-bg": props.isImageBg })}
    >
      <div className="wrapper">
        <div className="text-image__row grid-row">
          <div className="text-image-text grid-cell">
            <div className="text-image__overline">{props.overlay}</div>
            <div className="text-image__headline">{props.headline}</div>
            <p className="text-image__copy">{props.copy}</p>
            <ButtonSolid {...props.cta} className="text-image__button" />
          </div>
          <div className="grid-cell text-image-image">
            <img src={utils.assetPath(props.img)} alt="" />
          </div>
        </div>
      </div>
      {!!props.isImageBg && (
        <div
          className="text-image-bg"
          style={{ backgroundImage: `url(${utils.assetPath(props.img)})` }}
        />
      )}
    </div>
  );
};

export default TextImage;
